import { v4 as uuidv4 } from 'uuid'
const loadSections = (data) => {
  const list = data.map((item, index) => {
    return {
      sectionId: index,
      center_section_to_field: item.center_section_to_field,
      maintain_aspect_ratio: item.maintain_aspect_ratio,
      horizontal_ratio_percentage: String(item.keystone_correction.horizontal_ratio_percentage),
      vertical_ratio_percentage: String(item.keystone_correction.vertical_ratio_percentage),
      outline_laser_profile_id: item.outline_laser_profile.id,
      hatch_profile_ids: item.hatch_profiles.map((item) => item.id),
      marking_order: item.marking_order,
      preview_mark_type: item.preview_mark_type,
      preview_mark_speed: String(item.preview_mark_speed),

      name: item.name,
      width: String(item.default_size.width),
      height: String(item.default_size.height),
      offsetY: String(item.default_location.y),
      offsetX: String(item.default_location.x),
      sectionAngle: String(item.artwork_angle),
      radialAngle: String(item.radial_angle),

      price_model: undefined,
      price: undefined,
      image: null,
      _load: true,
    }
  })
  return list
  /*return {
        list : list,
        selected: false
    }*/
}

export default loadSections
